import { render, staticRenderFns } from "./ChatHistory.vue?vue&type=template&id=58c2b889"
import script from "../../controllers/chat/chat-history.js?vue&type=script&lang=js&external"
export * from "../../controllers/chat/chat-history.js?vue&type=script&lang=js&external"
import style0 from "./ChatHistory.vue?vue&type=style&index=0&id=58c2b889&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports